module.exports = __webpack_public_path__ + "img/Flag_of_Madagascar.65482ca5.svg";